// // () => {
// //     const [isOpen, setOpen] = useState(false);

// //     const handleCancel = () => {
// //       console.log('dialog canceled/closed!');
// //       setOpen(false);
// //     };

// //     const handleConfirm = () => {
// //       console.log('confirmed!');
// //       setOpen(false);
// //     };

// //     return (
// //       <Fragment>
// //         <h2>Dialog modal</h2>
// //         <button onClick={() => setOpen(true)}>Click to open modal</button>
// //         <Dialog
// //           title="Dialog modal title"
// //           open={isOpen}
// //           cancelText="Cancel"
// //           onCancel={handleCancel}
// //           confirmText="Confirm"
// //           onConfirm={handleConfirm}
// //           showConfirm={true}
// //         >
// //           Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
// //           ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
// //           reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt
// //           in culpa qui officia deserunt mollit anim id est laborum
// //         </Dialog>
// //       </Fragment>
// //     );
// //   }

// import React, { useState } from 'react';
// import Dialog from 'eymp-uicomps/components/Dialog';

// export function Dialogue() {
// //   const [size] = React.useState(type !== 'dashboard' ? 'short' : '');
// //   const [open, setOpen] = React.useState(false);
// //   const handleOnClose = () => setOpen(false);
// //   const handleViewClick = () => setOpen(true);

//   const [isOpen, setOpen] = useState(false);

//   const handleCancel = () => {
//     console.log('dialog canceled/closed!');
//     setOpen(false);
//   };

//   const handleConfirm = () => {
//     console.log('confirmed!');
//     setOpen(false);
//   };
//   return (
//     <React.Fragment>
//       <h2>Dialog modal</h2>
//         <button onClick={() => setOpen(true)}>Click to open modal</button>
//         <Dialog
//           title="Dialog modal title"
//           open={isOpen}
//           cancelText="Cancel"
//           onCancel={handleCancel}
//           confirmText="Confirm"
//           onConfirm={handleConfirm}
//           showConfirm={true}
//         >
//           Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
//           ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
//           reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt
//           in culpa qui officia deserunt mollit anim id est laborum
//         </Dialog>
//     </React.Fragment>
//   );
// }

import React from 'react';
import { Dialog } from 'eymp-uicomps';
import PropTypes from 'prop-types';

const InfoDialogue = ({ isOpen, handleCancel, children, title }) => {
  // const [isOpen, setOpen] = useState(false);

  // const handleCancel = () => {
  //   console.log('dialog canceled/closed!');
  //   setOpen(false);
  // };

  // const handleConfirm = () => {
  //   console.log('confirmed!');
  //   setOpen(false);
  // };
  return (
    <div>
      {/* <button onClick={() => setOpen(true)}>Click to open modal</button> */}
      <Dialog
        title={title}
        open={isOpen}
        onCancel={handleCancel}
        // onConfirm={handleConfirm}
        showConfirm={false}
        className="dialog-window">
        <div className="content">{children}</div>
      </Dialog>
    </div>
  );
};

InfoDialogue.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  // className: PropTypes.string,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
};

export default InfoDialogue;
